export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00764.c47a527f.png";